/** Booking tags keep their display emoji; matching ignores emoji and dash/spacing variants. */
export function hasConfirmedTrainBooking(guest) {
  return (guest.tags || []).some((tag) => {
    const label = String(tag).replace(/[\p{Extended_Pictographic}\uFE0F\u200D]/gu, '').trim();
    return /^train\s*[-–—]\s*\d+$/i.test(label);
  });
}
